import React from 'react';

import useFetchListings from '../../../../hooks/useFetchListings';
import ListingsList from '../../../../components/ListingsList';
import EmptyStateCard from '../../../../components/EmptyStateCard';
import trackEvent from '../../../../utils/trackEvent';
import { TSearchRequest, TSection } from '../../../../types/TConfigurablePage';

type TProps = {
  searchRequest: TSearchRequest;
  visualization: TSection['content']['visualization'];
};

const trackListingClick = () => {
  trackEvent({ eventAction: 'ClickListing' });
};

const Listings = ({ searchRequest, visualization }: TProps) => {
  const { listings, isLoading, isError, isEmpty } = useFetchListings({ searchRequest });

  if (isError) {
    return <EmptyStateCard message="shared.emptyStateText" />;
  }

  if (isEmpty) {
    return <EmptyStateCard />;
  }

  return (
    <ListingsList
      skeletonKey={JSON.stringify(searchRequest)}
      listings={listings}
      isLoading={isLoading}
      onClickListing={trackListingClick}
      visualization={visualization}
    />
  );
};

export default Listings;
